export default __webpack_public_path__ + "static/media/Bolt.8b5899f0.svg";